var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-4 d-flex align-center"},[_c('span',{staticClass:"pl-4 grey--text text-subtitle-2"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }